/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMagazine48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M34.5 46.683a.1.1 0 01-.146.089l-.007-.003a50.185 50.185 0 00-23.06-5.612H6V4.051h5.495c7.239 0 14.38 1.673 20.866 4.888L34.5 10v36.683z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M10.029 28.195H21M10.029 32.271h7.549M16.5 12H21M10 12h4.5M16.5 21H21M10 21h4.5M12.357 16.5h6.286M12.357 12v9M18.643 12v9'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M6 4l4.706-.68A81.642 81.642 0 0142.5 5v36.097'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M28.35 4.73C35.492 6.28 39 7.938 39 7.938v36.529'
      />
    </svg>
  );
}

export default SvgMagazine48;
